export default "__VITE_ASSET__BmxI3GQq__"